var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 733,
    height: 482,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A7FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "-.13%",
    x2: "100%",
    y1: "50.057%",
    y2: "50.057%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "176.072%",
    x2: "310.393%",
    y1: "-566.037%",
    y2: "-534.629%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "58.928%",
    x2: "52.269%",
    y1: "-257.998%",
    y2: "-277.344%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "156.099%",
    x2: "8.109%",
    y1: "-63.273%",
    y2: "-76.114%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "2361.044%",
    x2: "2162.651%",
    y1: "-16584.906%",
    y2: "-16647.547%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "241.391%",
    x2: "133.142%",
    y1: "-426.052%",
    y2: "-412.195%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "106.85%",
    x2: "-35.821%",
    y1: "22.502%",
    y2: "19.27%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "14.169%",
    x2: "114.168%",
    y1: "-41.335%",
    y2: "-41.335%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A7FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "40.386%",
    x2: "71.43%",
    y1: "39.515%",
    y2: "67.977%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "-12.531%",
    x2: "93.689%",
    y1: "44.923%",
    y2: "53.42%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "53.702%",
    x2: "43.721%",
    y1: "42.271%",
    y2: "80.595%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "190.926%",
    x2: "102.154%",
    y1: "-333.246%",
    y2: "-335.028%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "168.578%",
    x2: "111.53%",
    y1: "-126.252%",
    y2: "-126.942%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "56.989%",
    x2: "28.128%",
    y1: "43.618%",
    y2: "69.958%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "58.095%",
    x2: "57.212%",
    y1: "-1473.571%",
    y2: "-1370.204%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "-.04%",
    x2: "99.996%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: "99.032%",
    x2: "199.03%",
    y1: "-163.287%",
    y2: "-163.287%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: "124.306%",
    x2: "224.306%",
    y1: "-84.564%",
    y2: "-84.564%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "128.89%",
    x2: "24.06%",
    y1: "100.36%",
    y2: "153.095%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#362958",
    stopOpacity: 0.501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#34313D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: "3990.942%",
    x2: "3874.36%",
    y1: "-34225.187%",
    y2: "-34268.317%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFF1F7",
    d: "M583.08 92.214c-20.973-22.385-37.208-49.107-62.275-67.375-39.374-28.754-96.041-31.558-142.08-13.494-46.04 18.063-81.905 54.474-105.544 95.703-12.435 21.692-22.202 45.354-40.423 63.08-15.403 14.976-35.648 24.531-54.843 34.938-30.948 16.733-60.752 36.952-80.78 64.695-20.026 27.743-28.98 64.18-16.178 95.446 8.633 21.097 26.022 37.883 43.836 53.081 20.964 17.869 43.496 34.601 69.5 45.248 32.555 13.246 68.694 16.094 104.134 17.442 62.828 2.38 125.757.601 188.319-5.323 51.23-4.844 104.011-13.113 146.874-39.88 60.043-37.484 91-106.163 97.97-173.51 2.836-26.936 2.118-54.928-8.964-79.92-26.504-59.78-98.017-45.798-139.547-90.131z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M178.317 202.334s-16.6-2.947-21.25 8.669c-4.65 11.616 0 51.733 0 51.733L219 307l-40.683-104.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M256.202 379.727l-24.555 7.008c-3.568 1.01-7.31-.952-8.372-4.386-1.047-3.438.987-7.046 4.55-8.069l24.522-7.014c3.565-1.01 7.307.947 8.372 4.379 1.058 3.433-.96 7.045-4.517 8.082z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 395,
    r: 11,
    fill: "#25233A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 397.5,
    r: 5.5,
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 384,
    r: 11,
    fill: "#25233A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M214 384.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 399,
    r: 11,
    fill: "#25233A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M216 399.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M257.085 390.874l-50.787-10.046c-3.574-.717-5.884-4.13-5.168-7.636.732-3.5 4.21-5.764 7.785-5.066l50.787 10.027c3.574.717 5.884 4.13 5.168 7.637-.723 3.507-4.204 5.781-7.785 5.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M226 310h14v59c0 3.866-3.133 7-6.997 7a6.999 6.999 0 01-6.996-7v-59H226z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M231.187 386.708l-24.537 7.025c-3.568 1.014-7.314-.949-8.375-4.388-1.047-3.44.987-7.05 4.548-8.074l24.537-7.005c3.564-1.01 7.304.948 8.368 4.381 1.039 3.435-.99 7.034-4.541 8.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M236 386.26l-3.125.551a12.89 12.89 0 01-2.875.172l1.305-.228a10.302 10.302 0 002.507-.755l2.188.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M261 372.738a6.914 6.914 0 01-1.46 4.262L239 372.65a7.113 7.113 0 001.098-2.462l12.654-3.923a6.201 6.201 0 014.913.579c1.5.867 2.609 2.324 3.083 4.048.164.6.249 1.222.252 1.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M225.22 371.103a5.776 5.776 0 01-.22-1.58V311h5.943v63.07c-.059.31-.04.627.057.93a9.278 9.278 0 00-2.845-.511c-.69-.04-1.385-.04-2.076 0l.425-.1c.262-.04-.94-2.091-1.283-3.286z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M262.289 389.8c-.97.523-2.061.797-3.17.796a7.063 7.063 0 01-1.33-.13l-22.407-4.406-1.867-.363a6.54 6.54 0 01-2.133 1.055l-1.11.317-23.025 6.666c-3.514 1.007-7.202-.943-8.247-4.362 1.997 1.805 5.029 1.973 7.223.401 2.811-1.896 14.002-4.743 20.341-6.257 2.996-.698 5.288-3.05 5.848-6 .016-.173.042-.346.08-.517 1.056 1.113 2.997 2.362 6.505 3.423 8.64 2.589 22.667 4.304 22.667 4.304s2.532 2.42.625 5.073z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M264 388a7.624 7.624 0 01-2 2 119.75 119.75 0 002-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M226.3 370.559a6.82 6.82 0 001.7 3.13c-.21.039-.425.092-.641.151L206.088 380c-3.271-.813-5.426-3.865-5.044-7.146.381-3.28 3.181-5.781 6.556-5.854a7.14 7.14 0 011.35.132l17.35 3.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#503164",
    d: "M259 89.407s-.276-20.805-17.075-19.01c-16.8 1.793-15.511-5.095-22.687-4.339-7.175.757-15.51 7.786-13.117 16.468 2.395 8.682-6.332 10.623-12.064 17.21-5.733 6.587 1.349 11.976 11.006 18.416 9.657 6.44-.6 4.773 5.125 14.955 5.726 10.181 25.107-2.825 25.107-2.825L259 89.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M122.664 434.601l11.73.399v-93.745s.59-24.241 23.452-26.673c22.861-2.431 230.196-32.466 230.196-32.466s8.218-.87 12.951 14.901c4.733 15.771 9.34 77.787 9.34 77.787l63.64 8.577s1.68-109.55-21.302-115.595c-22.981-6.045-323.522 24.76-323.522 24.76s-22.29 116.352-6.485 142.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M122.664 434.601l11.73.399v-93.745s.59-24.241 23.452-26.673c22.861-2.431 230.196-32.466 230.196-32.466s8.218-.87 12.951 14.901c4.733 15.771 9.34 77.787 9.34 77.787l63.64 8.577s1.68-109.55-21.302-115.595c-22.981-6.045-323.522 24.76-323.522 24.76s-22.29 116.352-6.485 142.055z",
    opacity: 0.197
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M62 303.784s5.744-31.756 46.144-40.079l285.183-32.643s27.996-1.16 40.804 6.587c12.808 7.746 31.088 14.168 38.583 49.223 7.495 35.056 9.286 94.942 9.286 94.942l-7.09 1.1s-10.348-108.44-21.312-115.306c-10.963-6.865-307.402 35.255-307.402 35.255s-20.561 4.088-22.352 34.532c-1.79 30.443 0 96.605 0 96.605L62 409.057V303.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M355.425 243.844c-14.762-1.9-29.644-3.276-44.519-2.72-11.18.433-22.286 1.966-33.372 3.493l-97.775 13.503c-1.66.23-3.55.603-4.38 2.044-1.592 2.752 2.15 5.464 5.182 6.512 32.51 11.256 67.243 22.656 100.708 14.63 15.3-3.669 29.511-11.288 45.03-13.935 15.518-2.647 31.448-.21 46.933-2.706 14.557-2.345 28.417-9.009 43.172-9.074 4.525 0 9.183.577 13.475-.839 4.293-1.415 8.088-5.739 6.9-10.05-13.853-.478-29.404-3.007-42.992-.262-13.449 2.712-24.894-.596-38.362-.596z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M267 259.38l.57 2.114s16.881 10.173 16.775 10.501c-.106.328 70.024-16.24 70.024-16.24L356 251l-89 8.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M267 259.38l.57 2.114s16.881 10.173 16.775 10.501c-.106.328 70.024-16.24 70.024-16.24L356 251l-89 8.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M268 259.364L330.107 246 356 251.054 285.442 268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M268 259.364L330.107 246 356 251.054 285.442 268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M247.832 270.484l14.457.512s3.672.228 4.62-2.717c.95-2.945-5.89-9.16-6.622-9.277-.733-.118-19.76 5.22-17.017 10.556l4.562.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M247.832 270.484l14.457.512s3.672.228 4.62-2.717c.95-2.945-5.89-9.16-6.622-9.277-.733-.118-19.76 5.22-17.017 10.556l4.562.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M79 416.056l-7.058 21.677c-20.473 7.351-37.88 0-37.88 0L29 415s25.535 8.56 50 1.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M79 416.056l-7.058 21.677c-20.473 7.351-37.88 0-37.88 0L29 415s25.535 8.56 50 1.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M87 396l-2.284 16.943-5.786 3.008c-24.648 7.42-50.415-1.038-50.415-1.038l-4.443-3.283L22 396h65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M87 396l-2.284 16.943-5.786 3.008c-24.648 7.42-50.415-1.038-50.415-1.038l-4.443-3.283L22 396h65z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5,
    cy: 395,
    fill: "#2BD0D0",
    rx: 32.5,
    ry: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5,
    cy: 395,
    fill: "url(#o)",
    rx: 32.5,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M39.641 265.03c-3.182-1.515-6.603-2.658-9.356-4.87-5.547-4.5-6.953-12.248-8.69-19.198-1.736-6.951-5.097-14.593-11.944-16.587-2.562-.737-5.567-.445-7.515 1.39-2.053 1.933-2.47 5.11-1.908 7.914.561 2.804 1.928 5.316 2.985 7.974a36.878 36.878 0 012.172 19.477c-.865 5.389-2.932 10.851-1.605 16.134 2.252 8.964 13.47 14.22 13.78 23.457.212 6.233-4.885 12.001-3.73 18.135.852 4.538 5.005 8.08 5.23 12.692.25 5.23-4.662 9.655-4.424 14.885.237 5.23 5.427 8.725 8.815 12.839a21.453 21.453 0 014.827 12.193c.178 2.791-.179 5.682.726 8.327.66 1.933 1.98 3.575 3.004 5.316 1.13 1.88 1.981 3.914 3.341 5.655a13.696 13.696 0 0014.725 4.651c1.05-6.95.132-14.04.423-21.065.574-13.609 5.691-27.324 2.416-40.535-1.201-4.844-3.512-9.443-3.922-14.413-.363-4.44.812-8.838 1.631-13.217 1.69-9.044 1.664-18.394.97-27.538-.547-7.256-5.618-10.599-11.95-13.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M59.752 300.767c-.053 6.062 1.33 12.33-.612 18.085-1.47 4.362-4.702 7.934-6.371 12.223-3.85 9.899 1.33 21 .273 31.57-.44 4.354-1.936 8.537-2.88 12.813a51.236 51.236 0 00-.851 16.485 4.17 4.17 0 003.325 4.342A51.942 51.942 0 0062.711 399a26.638 26.638 0 013.445-18.59c5.274-8.63 15.522-14.446 17.43-24.359 1.29-6.712-1.715-13.524-1.502-20.355a21.886 21.886 0 014.482-12.548c2.48-3.227 5.839-5.723 8.147-9.07 5.546-8.066 3.817-18.848 2.168-28.494-1.65-9.647-2.607-20.748 3.91-28.057 2.062-2.31 4.748-4.044 6.617-6.513 4.163-5.504 3.112-13.983-1.73-18.902-4.84-4.92-12.635-6.28-19.218-4.116a13.86 13.86 0 00-7.01 4.76c-3.325 4.714-1.995 11.154-.585 16.757 1.23 4.867 2.221 10.483.539 15.39-1.257 3.651-4.443 5.63-7.15 8.172a38.903 38.903 0 00-12.502 27.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30C59B",
    d: "M53.062 354.522c-.938 6.593-2.292 13.239-2.57 19.851v.665a1.757 1.757 0 01-.111.479 51.684 51.684 0 00-.866 16.501c.036.893.261 1.768.66 2.566-.032.279-.072.551-.111.83a13.702 13.702 0 01-14.73-4.652c-1.32-1.741-2.213-3.775-3.342-5.655-1.057-1.748-2.345-3.39-3.005-5.317-.905-2.659-.549-5.536-.727-8.327a21.453 21.453 0 00-4.828-12.196c-3.389-4.087-8.587-7.516-8.818-12.833-.231-5.317 4.676-9.656 4.425-14.887-.224-4.612-4.379-8.154-5.23-12.693-1.157-6.135 3.962-11.903 3.731-18.137-.31-9.238-11.532-14.495-13.785-23.46-1.32-5.284.74-10.747 1.605-16.136a36.876 36.876 0 00-2.146-19.46c-1.057-2.658-2.424-5.163-2.986-7.975-.561-2.81-.145-5.981 1.909-7.922 1.982-1.834 4.954-2.126 7.517-1.389 6.856 1.994 10.204 9.664 11.948 16.615 1.744 6.952 3.144 14.694 8.692 19.2 2.742 2.227 6.176 3.356 9.36 4.872 6.34 3.017 11.413 6.36 11.955 13.55.66 9.145.72 18.496-.97 27.541-.82 4.38-1.982 8.78-1.632 13.219.35 4.44 2.272 8.64 3.527 12.946.139.485.277.977.396 1.469 1.665 6.839 1.13 13.757.132 20.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M49.718 394a7.789 7.789 0 01-.502-2.488c-.43-5.36-.216-10.78.637-16.047.023-.155.052-.31.08-.465-.171 6.346.374 12.744-.215 19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30C59B",
    d: "M107.393 251.014c-1.871 2.47-4.562 4.202-6.627 6.513-6.527 7.303-5.568 18.41-3.916 28.057 1.651 9.646 3.383 20.428-2.172 28.495-2.31 3.32-5.674 5.842-8.159 9.069a21.865 21.865 0 00-4.49 12.548c-.212 6.831 2.798 13.643 1.506 20.355-1.911 9.913-12.175 15.742-17.457 24.36A26.644 26.644 0 0062.654 399a51.824 51.824 0 01-10.064-2.715 5.425 5.425 0 01-2.344-1.415 2.503 2.503 0 01-.247-.345 6.232 6.232 0 01-.699-2.55c-.599-5.506-.3-11.073.886-16.484.033-.16.073-.319.113-.478.946-4.11 2.345-8.14 2.771-12.336a39.84 39.84 0 00-.16-8.166c1.006-6.971 1.545-13.882-.153-20.668-.12-.49-.26-.982-.4-1.467.127-.425.273-.85.44-1.268 1.672-4.289 4.909-7.86 6.38-12.223 1.939-5.756.56-12.023.613-18.085.087-10.47 4.823-20.58 12.429-27.725 2.71-2.542 5.901-4.52 7.16-8.172 1.685-4.907.666-10.523-.54-15.39-1.418-5.603-2.764-12.043.587-16.757 1.665-2.337 4.29-3.857 7.02-4.76 6.567-2.165 14.407-.804 19.249 4.116 4.842 4.92 5.868 13.43 1.698 18.902z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M225.573 146.146s-27.817 4.3-40.684 34.977c-12.867 30.677-6.176 68.683-5.951 72.027.225 3.344 39.428 17.85 50.635 17.85 11.208 0 13.542-11.229 13.542-11.229l-19.803-8.433 60.17-6.949h10.804l-5.951 10.032s11.743 1.23 19.592 1.511c7.848.281 13.178-15.24 14.057-22.959.88-7.717-34.667-75.458-39.977-79.47-5.31-4.013-19.717-13.817-56.434-7.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M258.392 88.776s5.032 2.83 4.58 11.985c-.453 9.155-3.29 22.932-6.153 26.5-2.864 3.57-12.88 4.968-12.88 4.968s5.464 12.977 9.53 16.326c4.066 3.349-4.086 15.687-12.015 11.639-7.928-4.049-17.12-14.216-17.12-14.216s6.612-12.245 4.376-18.69c-2.235-6.445-10.772-29.064-4.376-35.242 6.396-6.18 20.186-15.035 34.058-3.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.25,
    d: "M214.334 190L210 244.055 223.238 251 234 249.122l-13.428-16.504zM284 187s17.909 42.077 9.97 57l-6.116-1.16L284 187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M235.522 258.045s-6.766 5.775-3.746 10.267c3.02 4.491 6.625 4.363 9.631 2.355 3.006-2.009 8.911-6.776 15.946-4.588 7.035 2.188 8.744 3.58 8.744 3.58s3.705-2.316 2.744-4.639c-.962-2.323-8.32-9.85-10.452-10.825-2.132-.975-10.983 2.021-10.983 2.021s-6.503-1.758-11.884 1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M295.191 245.598s-6.385.759-7.998 4.957c-1.613 4.198-2.193 4.71-2.193 4.71s3.606.69 5.106-1.264 3.059-1.133 3.059-1.133l-.447 2.507s9.798 1.477 14.224-.11c4.425-1.589 6.325-3.453 6.325-3.453l1.733-4.24s-4.18-3.03-7.332-3.5c-3.152-.47-12.477 1.526-12.477 1.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25233A",
    d: "M328.893 290s21.934 16.687 19.984 39.259c-1.949 22.572-4.813 56.087-4.813 56.087s-8.846 3.722-14.707 0c-5.862-3.722-9.411-54.65-12.315-59.513-2.904-4.864-20.375-26.79-39.042-28.679L328.893 290z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M219 306.058s10.444 9.895 29.062 13.002c18.619 3.107 27.297 5.7 32.987 21.605 5.69 15.905 11.148 50.137 12.935 53.963 1.786 3.826 9.382 1.874 9.382 1.874s4.296-4.895 4.296-32.114c0-37.946 2.655-45.724-6.913-55.256-9.568-9.533-18.272-12.132-18.272-12.132L219 306.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25233A",
    d: "M294 396l1.82 14.197h3.408s21.948 1.187 22.636.675c.688-.513-1.057-11.243-9.372-10.94-8.316.304-8.861-2.023-8.861-2.023L294 396zm37-9.844L334.518 400l38.437-5.212s1.353-9.093-10.823-8.191c-3.214.234-5.608 2.465-9.471 2.485-3.863.02-7.563-1.543-9.511-4.082L331 386.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M461.804 212.337l-142.243 7.654c-3.44.181-6.376-2.47-6.561-5.926V112.473c.003-4.101 3.267-7.448 7.348-7.535l141.661-2.937a6.835 6.835 0 014.886 1.917 6.898 6.898 0 012.105 4.827v95.971c-.005 4.056-3.164 7.402-7.196 7.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD0D0",
    d: "M469.804 212.337l-142.25 7.655c-3.44.177-6.372-2.478-6.554-5.934V112.473c-.004-4.102 3.26-7.452 7.342-7.535l141.68-2.937c3.777-.07 6.898 2.943 6.978 6.738v95.977c-.005 4.057-3.164 7.403-7.196 7.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M469.804 212.337l-142.25 7.655c-3.44.177-6.372-2.478-6.554-5.934V112.473c-.004-4.102 3.26-7.452 7.342-7.535l141.68-2.937c3.777-.07 6.898 2.943 6.978 6.738v95.977c-.005 4.057-3.164 7.403-7.196 7.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3054",
    d: "M427.773 251.138L391.478 255s-11.053-2.23-10.455-3.862c.599-1.633 12.156-3.205 12.156-3.205v-65.804c-.1-.146-1.621-2.084-5.789-3.319-.807-.239-1.628-.43-2.459-.57a7.252 7.252 0 01-2.06-.624c-2.479-1.28.26-3.51 4.107-3.61a9.625 9.625 0 011.802.106h27.913s10.568 2.973 11.08 17.811c.511 14.839 0 59.215 0 59.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#51466B",
    d: "M398 251.277L391.322 255s-10.888-2.23-10.299-3.863c.59-1.632 11.995-3.205 11.995-3.205v-65.809c-.138-.152-1.807-1.898-5.703-3.318a28.64 28.64 0 00-4.452-1.195c-2.442-1.28.255-3.51 4.046-3.61 3.228.445 9.585 4.028 9.998 6.073.412 2.044 1.093 71.204 1.093 71.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M263 389c-.881 1.001-1.29 1.37-.77.547.27-.159.527-.342.77-.547z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWorking);
export default __webpack_public_path__ + "static/media/illustration-working.c9b5ef5452363d8be3df709375d50bd0.svg";
export { ForwardRef as ReactComponent };